const styles = theme => ({
  main:{
    display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
  },
  paper: {
    margin: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  intercomLogoHolder: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
})

export default styles
